/**
 * @module Footer
 * @description Site Footer
 */
import React, { FC } from 'react';
import Link from 'next/link';
import { Navigation, Menu } from 'ui/components/Navigation';
import styles from '../styles/SocialMenu.module.css';

interface SocialLink {
  icon: string;
  href: string;
  title: string;
  target?: string;
}

interface Props {
  links: SocialLink[];
}

const SocialNavigation: FC<Props> = ({ ...props}) => {
  const {
    links
  } = props;

  return (
    <Navigation className={ styles.navigation } ariaLabel="Social Navigation">
      <Menu className={ styles.menu } ariaLabel="Social Menu">
        <>
        { links.map( ( link: SocialLink, index: number ) => (
            <li key={ index } className={ styles.li } role="menuitem">
              <Link
                href={ link.href }
                target={ link.target || '_blank' }
                className={ `${ styles.link } ${ link.icon }` }
                title={ link.title }
              >
                { link.title }
              </Link>
            </li>
        ) ) }
        </>
      </Menu>
    </Navigation>
  );
};

SocialNavigation.displayName = 'Social Navigation';

export default SocialNavigation;
